import { GetUsersActivityTableFiltersActionTypes, GetUsersActivityTableFiltersState, SET_USERS_ACTIVITY_TABLE_FILTERS } from 'store/reducers/users-activity/get-users-activity-table-filters/types';
import { UserStatuses } from 'store/reducers/session/types';

const defaultState: GetUsersActivityTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: { dates: 'LastThreeMonths', status: UserStatuses.Active },
  exists: false,
};

export default function usersActivityTableFilters(state = defaultState, action: GetUsersActivityTableFiltersActionTypes): GetUsersActivityTableFiltersState {
  switch (action.type) {
    case SET_USERS_ACTIVITY_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
